export default __webpack_public_path__ + "static/media/fuelEnDetailRoundTablet.6e461dd9.jpg";